import { render, staticRenderFns } from "./ActiveBacklog-Stacked.vue?vue&type=template&id=6666316a&scoped=true&"
import script from "./ActiveBacklog-Stacked.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklog-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklog-Stacked.vue?vue&type=style&index=0&id=6666316a&scoped=true&lang=css&"
import style1 from "./ActiveBacklog-Stacked.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666316a",
  null
  
)

export default component.exports